import { enqueueSnackbar } from 'notistack';
import { store } from '../../redux/store';
import {
  onReceiveMessage,
  getConversations,
  handleRemoteChatFinalization,
  resetActiveConversation,
  updateMessageStatus,
  updateMessageAttachments,
} from '../../redux/slices/chat';
import { getEvents } from '../../redux/slices/calendar';
import { PATH_DASHBOARD } from '../../routes/paths';
import { soundManager } from '../soundManager';
import { showNativeNotification } from '../notificationsPermission';

export class AgentHandlers {
  static async handleChatTransfer(dispatch, message, user) {
    const transferredChatId = message.data?.chatId;

    // Verifica se o chat foi transferido DESTE usuário
    if (message.data?.fromUserId === user._id && transferredChatId) {
      const currentActiveConversationId = store.getState().chat.activeConversationId;

      if (transferredChatId === currentActiveConversationId) {
        dispatch(resetActiveConversation());
      }

      dispatch(getConversations(user));
      await soundManager.playSound('leave');
    }
  }

  static async handleChatAssignment(dispatch, message, user) {
    if (message.data?.agentId === user._id) {
      dispatch(getConversations(user));
      await soundManager.playSound('new', message.data.chatId);
    }
  }

  static async handleIncomingMessages(dispatch, message, user) {
    if (user._id !== message.data?.agentId || !message.data?.messages?.length) {
      return;
    }

    const firstMessage = message.data.messages[0];

    dispatch(
      onReceiveMessage({
        conversationId: message.data.chatId,
        text: firstMessage.text,
        uid: firstMessage.uid,
        from: firstMessage.from,
        timestamp: firstMessage.timestamp,
        attachments: firstMessage.attachments,
      })
    );

    await soundManager.playSound('new', firstMessage.uid);

    // Notifica apenas se não estiver na tela de chat
    if (!this.isInChatScreen(message.data.chatId)) {
      // var se tiver true na config da empresa
      const notificationMessage = user.company.config.allowNotificationsForNewMessages;

      if (notificationMessage) {
        // Carrega a conversa no Redux antes de buscar o nome
        await dispatch(getConversations(user));

        // Busca a conversa no Redux state
        const state = store.getState();
        const conversation = state.chat.conversations.byId?.[message.data.chatId];

        // Busca o nome do cliente na conversa
        const clientName = conversation?.sender?.name || conversation?.sender?.phone || 'Cliente';

        // Trunca a mensagem se for muito longa (máximo 20 caracteres)
        const maxLength = 20;
        const truncatedMessage =
          firstMessage.text.length > maxLength ? `${firstMessage.text.substring(0, maxLength)}...` : firstMessage.text;

        const chatIdForClick = message.data.chatId;

        // Notify personalizado com clique
        enqueueSnackbar(`Nova mensagem\n${clientName}: "${truncatedMessage}"`, {
          variant: 'success',
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          style: {
            cursor: 'pointer',
            whiteSpace: 'pre-line',
          },
          // Adiciona um listener de clique no container
          SnackbarProps: {
            onClick: () => {
              window.location.href = `/dashboard/chat/${chatIdForClick}`;
              console.log('Toast clicado, navegando para o chat do cliente.', chatIdForClick);
            },
          },
        });

        // Exibe NOTIFICAÇÃO NATIVA do navegador
        showNativeNotification({
          title: 'Nova mensagem recebida',
          sender: clientName,
          message: firstMessage.text,
          chatId: message.data.chatId,
        });
      } else {
        // Apenas o notify se notificações allowNotificationsForNewMessages no banco estiver desabilitada
        enqueueSnackbar('Você recebeu uma nova mensagem!', {
          variant: 'success',
          autoHideDuration: 5000,
        });
      }
    }
  }

  static handleMessageUpdate(dispatch, message) {
    if (!message.data?.chatId || !message.data?.uid || !window.location.pathname.includes(message.data.chatId)) {
      return;
    }

    if (message.data.attachments) {
      dispatch(
        updateMessageAttachments({
          conversationId: message.data.chatId,
          uid: message.data.uid,
          attachments: message.data.attachments,
        })
      );
    }

    if (message.data.status) {
      dispatch(
        updateMessageStatus({
          conversationId: message.data.chatId,
          uid: message.data.uid,
          status: message.data.status,
        })
      );
    }
  }

  static async handleChatFinalization(dispatch, message, user) {
    if (!message.data?.chatId) {
      console.error('Socket event "chatFinalization" (agent) sem chatId:', message.data);
      return;
    }

    dispatch(handleRemoteChatFinalization(message.data, user));

    if (user._id === message.data.agentId) {
      await soundManager.playSound('leave');
    }
  }

  static handleVideoSchedule(dispatch, message) {
    if (window.location.pathname.includes(PATH_DASHBOARD.videocall.root) && message.data?.serviceId) {
      dispatch(getEvents(message.data.serviceId));
    }
  }

  static handleUserStatusUpdate(message, user, update) {
    if (message.data && user._id === message.data.userId) {
      const updatedUser = { ...user, ...message.data.user };
      update(updatedUser);
    }
  }

  static isInChatScreen() {
    return window.location.pathname.includes(PATH_DASHBOARD.chat.root);
  }
}
